/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Language_LabelInputs */

const en_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const fr_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const de_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

const it_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lingua`)
};

const ru_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык`)
};

const es_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const zh_cn2_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const ja_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語`)
};

const hi_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा`)
};

const pt_pt2_translation_merge_language_label = /** @type {(inputs: Translation_Merge_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguagem`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Translation_Merge_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_language_label = /** @type {((inputs?: Translation_Merge_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_language_label(inputs)
	if (locale === "de") return de_translation_merge_language_label(inputs)
	if (locale === "it") return it_translation_merge_language_label(inputs)
	if (locale === "ru") return ru_translation_merge_language_label(inputs)
	if (locale === "es") return es_translation_merge_language_label(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_language_label(inputs)
	if (locale === "ja") return ja_translation_merge_language_label(inputs)
	if (locale === "hi") return hi_translation_merge_language_label(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_language_label(inputs)
	return en_translation_merge_language_label(inputs)
});